export default __webpack_public_path__ + "media/purpleHighlight.192734f4b62f536a3fad494638d1ba95.svg";